export default __webpack_public_path__ + "static/media/techBlog.bfe480f4.png";